import { rufe } from './client';

/** Der Feiertagskalender je Standort (FRS-08, FRS-09). */
export type Kalenderstandort = { readonly kennung: string; readonly bezeichnung: string; readonly bundesland: string };
export type Feiertag = { readonly geltung: string; readonly tag: string; readonly bezeichnung: string };
export type Schliesstag = { readonly standort: string; readonly tag: string; readonly bezeichnung: string };
export type BetroffenerTermin = {
  readonly id: string;
  readonly beginn: string;
  readonly artikel: string;
  readonly gebuchtePlaetze: number;
};

export type Kalender = {
  readonly jahr: number;
  readonly standorte: readonly Kalenderstandort[];
  readonly feiertage: readonly Feiertag[];
  readonly schliesstage: readonly Schliesstag[];
  readonly gepflegtBis: string | null;
  readonly pflegeFaellig: boolean;
};

export async function lesen(jahr: number): Promise<Kalender> {
  return rufe<Kalender>(`/kalender?jahr=${String(jahr)}`);
}

export async function feiertageEintragen(bisJahr: number): Promise<{ readonly eingetragen: number }> {
  return rufe(`/kalender/feiertage/eintragen`, { verfahren: 'POST', rumpf: { bisJahr } });
}

export async function feiertagAnlegen(feiertag: Feiertag): Promise<void> {
  await rufe<void>('/kalender/feiertage', { verfahren: 'POST', rumpf: feiertag });
}

export async function feiertagLoeschen(geltung: string, tag: string): Promise<void> {
  await rufe<void>(`/kalender/feiertage/${encodeURIComponent(geltung)}/${tag}`, { verfahren: 'DELETE' });
}

export async function schliesstagAnlegen(
  schliesstag: Schliesstag,
): Promise<{ readonly betroffeneTermine: readonly BetroffenerTermin[] }> {
  return rufe('/kalender/schliesstage', { verfahren: 'POST', rumpf: schliesstag });
}

export async function schliesstagLoeschen(standort: string, tag: string): Promise<void> {
  await rufe<void>(`/kalender/schliesstage/${encodeURIComponent(standort)}/${tag}`, { verfahren: 'DELETE' });
}
